import { render, staticRenderFns } from "./titlepublic.vue?vue&type=template&id=226f1b90&scoped=true&"
import script from "./titlepublic.vue?vue&type=script&lang=js&"
export * from "./titlepublic.vue?vue&type=script&lang=js&"
import style0 from "./titlepublic.vue?vue&type=style&index=0&id=226f1b90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226f1b90",
  null
  
)

export default component.exports